<script setup lang="ts">
/**
 * HALAMAN JUALAN — Ebook "Melek Komputer".
 *
 * Buku ini corong, bukan tujuan akhir. Orang yang membeli panduan komputer
 * dasar seharga Rp20.000 adalah orang yang pekerjaannya masih manual — persis
 * calon pengguna alat CoreAsia. Karena itu halaman ini ditutup dengan jalan
 * menuju layanan, bukan berhenti di tombol beli.
 */

const HARGA = 20000
const HALAMAN = 95
const SKU = 'ebook-melek-komputer'
const PATH = '/buku/melek-komputer'

const apiBase = useApiBase()
const situs = useSitusUrl()

const bagian = [
  {
    nomor: '1',
    nama: 'Mengenal Komputer',
    ringkas: 'Fondasi. Terlihat sederhana, tapi sebagian besar masalah pemula berakar di sini.',
    bab: [
      { no: 1, judul: 'Isi Perut Komputer: Hardware dan Software' },
      { no: 2, judul: 'Sistem Operasi: Ngobrol sama Windows' },
      { no: 3, judul: 'File, Folder, dan Cara Tidak Kehilangan Data' },
      { no: 4, judul: 'Internet, Browser, dan Keamanan Dasar' }
    ]
  },
  {
    nomor: '2',
    nama: 'Dokumen yang Rapi',
    ringkas: 'Dari mengetik apa adanya ke dokumen yang enak dibaca orang lain.',
    bab: [{ no: 5, judul: 'Microsoft Word dari Nol sampai Rapi' }]
  },
  {
    nomor: '3',
    nama: 'Excel: Jantung Semua Rumus',
    ringkas: 'Bagian terbesar buku ini. Empat belas bab, dari sel pertama sampai laporan nyata.',
    bab: [
      { no: 6, judul: 'Kenalan sama Excel: Sel, Baris, Kolom' },
      { no: 7, judul: 'Aturan Main Rumus di Excel' },
      { no: 8, judul: 'Referensi Sel: Relatif, Absolut, Campuran' },
      { no: 9, judul: 'Rumus Hitungan Dasar' },
      { no: 10, judul: 'Rumus Logika: IF dan Keluarganya' },
      { no: 11, judul: 'Menghitung dengan Syarat: SUMIF, COUNTIF, dan Kawan' },
      { no: 12, judul: 'Mengolah Teks' },
      { no: 13, judul: 'Tanggal dan Waktu' },
      { no: 14, judul: 'Mencari Data: VLOOKUP, INDEX-MATCH, XLOOKUP' },
      { no: 15, judul: 'Merapikan Tampilan dan Format' },
      { no: 16, judul: 'Tabel, PivotTable, dan Grafik' },
      { no: 17, judul: 'Menjaga Data Tetap Bersih' },
      { no: 18, judul: 'Studi Kasus: Tiga Laporan Nyata' },
      { no: 19, judul: 'Kalau Rumus Error: Panduan Bongkar Masalah' }
    ]
  },
  {
    nomor: '4',
    nama: 'Logika dan Matematika Komputer',
    ringkas: 'Kenapa komputer bekerja seperti itu, dan apa yang sebenarnya dilakukan seorang programmer.',
    bab: [
      { no: 20, judul: 'Biner, Desimal, dan Heksadesimal' },
      { no: 21, judul: 'Satuan Data dan Rumus Ukuran File' },
      { no: 22, judul: 'Aljabar Boolean dan Gerbang Logika' },
      { no: 23, judul: 'Algoritma, Flowchart, dan Pseudocode' },
      { no: 24, judul: 'Kenalan sama Pemrograman' },
      { no: 25, judul: 'Rumus-rumus Praktis Dunia IT' }
    ]
  },
  {
    nomor: '5',
    nama: 'Latihan dan Lampiran',
    ringkas: 'Bagian yang dibuka berulang kali setelah bukunya selesai dibaca.',
    bab: [{ no: 26, judul: 'Kunci Jawaban Latihan' }]
  }
]

const lampiran = [
  { kode: 'A', judul: 'Cheat Sheet Rumus Excel' },
  { kode: 'B', judul: 'Shortcut Keyboard yang Wajib Hafal' },
  { kode: 'C', judul: 'Glosarium Istilah' },
  { kode: 'D', judul: 'Peta Belajar 8 Minggu' }
]

const cuplikan = [
  { src: '/buku/isi-excel-dasar.jpg', judul: 'Bab 6 — kenalan sama sel, baris, dan kolom' },
  { src: '/buku/isi-vlookup.jpg', judul: 'Bab 14 — memilih antara VLOOKUP, INDEX-MATCH, dan XLOOKUP' },
  { src: '/buku/isi-pivot.jpg', judul: 'Bab 16 — tabel, PivotTable, dan grafik' }
]

const faq: Faq[] = [
  {
    tanya: 'Formatnya apa, dan bisa dibaca di HP?',
    jawab:
      `PDF, ${HALAMAN} halaman. Bisa dibuka di HP, tablet, laptop, dan pembaca ebook mana pun. ` +
      'Tata letaknya dibuat satu kolom supaya tetap enak dibaca di layar kecil.'
  },
  {
    tanya: 'Boleh dicetak?',
    jawab:
      'Boleh, untuk keperluan sendiri. Yang tidak diperbolehkan adalah membagikan berkasnya, ' +
      'mengunggah ulang, atau menjual kembali isinya.'
  },
  {
    tanya: 'Saya tidak punya Microsoft Excel. Masih berguna?',
    jawab:
      'Masih. Hampir semua rumus di buku ini jalan di Google Sheets (gratis, lewat browser) ' +
      'dan LibreOffice Calc (gratis, diinstal). Perbedaan penulisan titik koma dan koma ' +
      'dijelaskan di bagian awal.'
  },
  {
    tanya: 'Bagaimana cara menerima bukunya setelah bayar?',
    jawab:
      'Setelah pembayaran QRIS berhasil, tautan unduh dikirim ke email Anda, biasanya kurang ' +
      'dari dua menit. Berkasnya diterbitkan atas nama Anda dan memuat kode lisensi di setiap ' +
      'halaman. Tautannya berlaku 7 hari dan bisa diminta ulang kapan saja.'
  },
  {
    tanya: 'Kalau edisi berikutnya terbit, harus beli lagi?',
    jawab: 'Tidak. Pembaruan edisi berikutnya gratis untuk pemilik lisensi.'
  },
  {
    tanya: 'Bisa untuk tim kantor atau sekolah?',
    jawab:
      'Bisa. Lisensi kolektif tersedia dengan harga khusus — kirim pesan ke hello@coreasia.id ' +
      'dengan perkiraan jumlah pembacanya.'
  },
  {
    tanya: 'Kalau isinya tidak sesuai harapan?',
    jawab:
      'Lihat kebijakan pengembalian dana kami. Untuk barang digital yang sudah diunduh, ' +
      'hubungi kami dulu — kami lebih suka menyelesaikannya lewat percakapan daripada aturan.'
  }
]

pakaiSeo({
  judul: 'Melek Komputer — panduan komputer dasar, rumus Excel, dan logika pemrograman',
  deskripsi:
    `Ebook ${HALAMAN} halaman untuk pemula total: komputer dan sistem operasi, 90+ rumus ` +
    'Excel dengan contoh kasus nyata, serta logika dan dasar pemrograman. Latihan tiap bab ' +
    `lengkap dengan kunci jawaban. Rp${new Intl.NumberFormat('id-ID').format(HARGA)}, langsung diunduh.`,
  path: PATH,
  jsonLd: [
    jsonLdBuku({
      judul: 'Melek Komputer',
      deskripsi:
        'Panduan belajar mandiri untuk pemula total: komputer dasar, rumus Excel, dan logika ' +
        'di balik semua program.',
      url: situs + PATH,
      gambar: situs + '/buku/sampul.jpg',
      penulis: 'Dedi Fardiyanto',
      penerbit: 'CoreAsia',
      halaman: HALAMAN,
      harga: HARGA
    }),
    jsonLdFaq(faq),
    jsonLdRemah(situs, [
      ['Beranda', '/'],
      ['Buku', '/buku/melek-komputer']
    ])
  ]
})

// ── Sampel gratis ────────────────────────────────────────────────────────
const emailSampel = ref('')
const mengirimSampel = ref(false)
const galatSampel = ref('')
const sampelSiap = ref(false)

async function ambilSampel() {
  const email = emailSampel.value.trim()
  if (!email) return
  mengirimSampel.value = true
  galatSampel.value = ''
  try {
    const res = await $fetch<{ url?: string }>(`${apiBase}/api/ebook/sampel`, {
      method: 'POST',
      body: { email, sumber: PATH }
    })
    if (res.url) {
      sampelSiap.value = true
      window.location.href = res.url
    }
  } catch (err) {
    galatSampel.value = pesanError(err, 'Gagal menyiapkan sampel. Coba lagi sebentar lagi.')
  } finally {
    mengirimSampel.value = false
  }
}

const jumlahBab = bagian.reduce((n, b) => n + b.bab.length, 0)
const rupiah = new Intl.NumberFormat('id-ID').format(HARGA)
</script>

<template>
  <!-- pb-24 memberi ruang bagi bilah beli di bawah pada HP; tanpa itu tombol
       WhatsApp dan footer tertutup bilahnya. -->
  <main class="pb-24 lg:pb-0">
    <!-- ── Hero ───────────────────────────────────────────────────────── -->
    <section class="mx-auto grid w-full max-w-5xl gap-10 px-4 py-12 sm:py-16 md:grid-cols-[1fr_320px] md:items-start">
      <div>
        <p class="text-xs font-semibold uppercase tracking-widest text-brand">Panduan belajar mandiri</p>
        <h1 class="mt-3 text-3xl font-bold leading-tight text-ink sm:text-4xl">Melek Komputer</h1>
        <p class="mt-4 text-lg text-muted">
          Dari nol sampai bisa: komputer dasar, rumus Excel, dan logika di balik semua program.
        </p>

        <ul class="mt-6 space-y-2 text-ink">
          <li class="flex gap-3">
            <span class="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-brand" />
            Komputer dan sistem operasi untuk pemula total
          </li>
          <li class="flex gap-3">
            <span class="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-brand" />
            90+ rumus Excel dengan contoh kasus nyata
          </li>
          <li class="flex gap-3">
            <span class="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-brand" />
            Logika, biner, algoritma, dan dasar pemrograman
          </li>
          <li class="flex gap-3">
            <span class="mt-2 h-1.5 w-1.5 flex-none rounded-full bg-brand" />
            Latihan tiap bab lengkap dengan kunci jawaban
          </li>
        </ul>

        <div class="mt-8 flex flex-wrap items-center gap-4">
          <CaButton
            size="lg"
            icon="i-lucide-shopping-cart"
            :to="`/checkout?sku=${SKU}`"
            :label="`Beli sekarang — Rp${rupiah}`"
          />
          <a class="text-sm text-muted underline" href="#sampel">Baca 12 halaman pertama dulu</a>
        </div>
        <p class="mt-3 text-sm text-muted">
          Harga perkenalan. PDF {{ HALAMAN }} halaman, langsung diunduh setelah bayar.
        </p>
      </div>

      <img
        src="/buku/sampul.jpg"
        alt="Sampul ebook Melek Komputer"
        width="1075"
        height="1521"
        class="w-full rounded-xl border border-line shadow-lg"
      />
    </section>

    <!-- ── Untuk siapa ────────────────────────────────────────────────── -->
    <section class="border-t border-line bg-surface">
      <div class="mx-auto w-full max-w-5xl px-4 py-12">
        <h2 class="text-xl font-semibold text-ink">Buku ini untuk siapa</h2>
        <p class="mt-3 max-w-3xl text-muted">
          Untuk orang yang pernah bilang: "Aku bisa sih pakai komputer, tapi cuma buat buka
          WhatsApp Web sama nonton YouTube." Atau: "Excel itu yang ada rumus-rumusnya kan? Aku
          nggak ngerti sama sekali." Tidak ada satu pun bab yang mengasumsikan Anda sudah tahu
          istilah teknis.
        </p>
        <div class="mt-8 grid gap-4 sm:grid-cols-3">
          <CaCard tone="soft">
            <h3 class="font-semibold text-ink">Komputer &amp; Word</h3>
            <p class="mt-2 text-sm text-muted">
              Pakai komputer tanpa takut salah pencet, dan bikin dokumen yang rapi.
            </p>
          </CaCard>
          <CaCard tone="soft">
            <h3 class="font-semibold text-ink">Excel</h3>
            <p class="mt-2 text-sm text-muted">
              Bikin laporan penjualan, rekap absensi, dan hitungan otomatis sendiri.
            </p>
          </CaCard>
          <CaCard tone="soft">
            <h3 class="font-semibold text-ink">Logika komputer</h3>
            <p class="mt-2 text-sm text-muted">
              Paham kenapa komputer bekerja seperti itu, dan siap belajar coding.
            </p>
          </CaCard>
        </div>
      </div>
    </section>

    <!-- ── Cuplikan isi ───────────────────────────────────────────────── -->
    <section class="mx-auto w-full max-w-5xl px-4 py-12">
      <h2 class="text-xl font-semibold text-ink">Seperti apa isinya</h2>
      <div class="mt-6 grid gap-5 sm:grid-cols-3">
        <figure v-for="c in cuplikan" :key="c.src">
          <img
            :src="c.src"
            :alt="c.judul"
            width="909"
            height="1287"
            loading="lazy"
            class="w-full rounded-lg border border-line"
          />
          <figcaption class="mt-2 text-sm text-muted">{{ c.judul }}</figcaption>
        </figure>
      </div>
    </section>

    <!-- ── Daftar isi ─────────────────────────────────────────────────── -->
    <section class="border-t border-line bg-surface">
      <div class="mx-auto w-full max-w-5xl px-4 py-12">
        <h2 class="text-xl font-semibold text-ink">Daftar isi lengkap</h2>
        <p class="mt-2 text-muted">{{ jumlahBab }} bab dan {{ lampiran.length }} lampiran, {{ HALAMAN }} halaman.</p>

        <div class="mt-8 space-y-8">
          <div v-for="b in bagian" :key="b.nomor">
            <h3 class="text-xs font-semibold uppercase tracking-widest text-brand">
              Bagian {{ b.nomor }} · {{ b.nama }}
            </h3>
            <p class="mt-1 text-sm text-muted">{{ b.ringkas }}</p>
            <ul class="mt-3 divide-y divide-line border-t border-line">
              <li v-for="bab in b.bab" :key="bab.no" class="flex gap-4 py-2.5">
                <span class="w-14 flex-none font-mono text-sm text-muted">Bab {{ bab.no }}</span>
                <span class="text-ink">{{ bab.judul }}</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 class="text-xs font-semibold uppercase tracking-widest text-brand">Lampiran</h3>
            <ul class="mt-3 divide-y divide-line border-t border-line">
              <li v-for="l in lampiran" :key="l.kode" class="flex gap-4 py-2.5">
                <span class="w-14 flex-none font-mono text-sm text-muted">{{ l.kode }}</span>
                <span class="text-ink">{{ l.judul }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- ── Sampel gratis ──────────────────────────────────────────────── -->
    <section id="sampel" class="mx-auto w-full max-w-3xl scroll-mt-20 px-4 py-12">
      <CaCard tone="emas">
        <h2 class="text-xl font-semibold text-ink">Baca 12 halaman pertama, gratis</h2>
        <p class="mt-2 text-muted">
          Kata pengantar, cara memakai buku ini, daftar isi lengkap, dan bab pertama tentang isi
          perut komputer. Masukkan email, berkasnya langsung terunduh.
        </p>
        <!-- Setelah sampel diambil, formulirnya diganti langkah berikutnya.
             Orang yang baru menyerahkan emailnya adalah pengunjung paling
             hangat di halaman ini, dan sebelumnya ia hanya diberi satu kalimat
             "sedang diunduh" tanpa jalan ke mana pun. Tautan sampel dikirim
             sebagai lampiran, jadi halaman ini tetap terbuka dan kartu ini
             benar-benar terlihat. -->
        <div v-if="sampelSiap" class="mt-5">
          <p class="font-semibold text-ink">Sampel sedang diunduh.</p>
          <p class="mt-1 text-muted">
            Sampel berhenti di bab awal. Rumus Excel dari VLOOKUP sampai PivotTable, logika
            pemrograman, dan seluruh kunci jawaban latihan ada di buku lengkap.
          </p>
          <div class="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center">
            <CaButton
              size="lg"
              icon="i-lucide-shopping-cart"
              :to="`/checkout?sku=${SKU}`"
              :label="`Beli buku lengkap — Rp${rupiah}`"
            />
            <button
              type="button"
              class="text-sm text-muted underline"
              :disabled="mengirimSampel"
              @click="ambilSampel"
            >
              Unduh ulang sampel
            </button>
          </div>
        </div>
        <form v-else class="mt-5 flex flex-col gap-2 sm:flex-row" @submit.prevent="ambilSampel">
          <CaInput
            v-model="emailSampel"
            type="email"
            inputmode="email"
            autocomplete="email"
            placeholder="email Anda"
            class="flex-1"
          />
          <CaButton
            type="submit"
            :loading="mengirimSampel"
            :disabled="!emailSampel.trim()"
            label="Kirim sampelnya"
          />
        </form>
        <p v-if="galatSampel" class="mt-3 text-sm text-danger">{{ galatSampel }}</p>
        <p class="mt-3 text-xs text-muted">
          Email ini hanya dipakai untuk mengirim sampel, dan tidak dijual ke siapa pun. Lihat
          <NuxtLink class="underline" to="/privasi">kebijakan privasi</NuxtLink>.
        </p>
      </CaCard>
    </section>

    <!-- ── FAQ ────────────────────────────────────────────────────────── -->
    <section class="border-t border-line bg-surface">
      <div class="mx-auto w-full max-w-3xl px-4 py-12">
        <h2 class="text-xl font-semibold text-ink">Pertanyaan yang sering masuk</h2>
        <dl class="mt-6 divide-y divide-line border-t border-line">
          <div v-for="f in faq" :key="f.tanya" class="py-4">
            <dt class="font-medium text-ink">{{ f.tanya }}</dt>
            <dd class="mt-1.5 text-muted">{{ f.jawab }}</dd>
          </div>
        </dl>
        <p class="mt-6 text-sm text-muted">
          Soal pengembalian dana, lihat
          <NuxtLink class="underline" to="/refund#ebook">kebijakan refund untuk ebook</NuxtLink>.
        </p>
      </div>
    </section>

    <!-- ── Beli ───────────────────────────────────────────────────────── -->
    <section class="mx-auto w-full max-w-3xl px-4 py-12 text-center">
      <p class="text-sm text-muted">Harga perkenalan</p>
      <p class="mt-1 text-4xl font-bold text-ink">Rp{{ rupiah }}</p>
      <p class="mt-2 text-muted">PDF {{ HALAMAN }} halaman · bayar QRIS · langsung diunduh</p>
      <CaButton
        class="mt-6"
        size="lg"
        icon="i-lucide-shopping-cart"
        :to="`/checkout?sku=${SKU}`"
        label="Beli sekarang"
      />
    </section>

    <!-- ── Corong ke layanan ──────────────────────────────────────────── -->
    <section class="border-t border-line bg-surface">
      <div class="mx-auto w-full max-w-3xl px-4 py-12">
        <h2 class="text-xl font-semibold text-ink">Butuh sistem seperti ini untuk bisnis Anda?</h2>
        <p class="mt-3 text-muted">
          Buku ini bagian dari cara kami bekerja: teknologi baru berguna kalau orang yang
          memakainya paham apa yang sedang mereka lakukan. Kalau proses kerja di kantor Anda
          masih manual dan memakan waktu, atau tim Anda perlu dilatih agar lebih produktif
          dengan alat yang sudah ada, kirim pesan saja. Tidak perlu formal.
        </p>
        <div class="mt-6 flex flex-wrap gap-3">
          <CaButton variant="ghost" href="https://coreasia.id" label="Lihat layanan CoreAsia" />
          <CaButton variant="ghost" href="mailto:hello@coreasia.id" label="hello@coreasia.id" />
          <CaButton variant="ghost" href="https://wa.me/6285121533395" label="WhatsApp" />
        </div>
      </div>
    </section>

    <!-- Bilah beli bawah — HP saja. Diukur di layar 375 px: halaman ini setinggi
         hampir 10.000 px, dan di antara tombol beli di hero dan di bagian harga
         ada sekitar 7.900 px tanpa satu tombol beli pun — tepat di daftar isi
         dan cuplikan yang dibaca orang yang sedang menimbang. Instans kaca
         kedua dan terakhir di halaman ini (header yang pertama); lebih dari
         dua membuat frame drop di GPU kelas bawah. -->
    <CaGlassBar posisi="bawah" class="lg:hidden">
      <div class="flex items-center gap-3 px-4 py-3">
        <div class="min-w-0 flex-1">
          <p class="ca-num text-lg font-extrabold leading-none text-ink">Rp{{ rupiah }}</p>
          <p class="ca-caption text-muted mt-1 truncate">PDF {{ HALAMAN }} halaman</p>
        </div>
        <CaButton variant="emas" size="lg" :to="`/checkout?sku=${SKU}`" class="shrink-0">
          Beli, bayar QRIS
        </CaButton>
      </div>
    </CaGlassBar>
  </main>
</template>
